(function () {
  'use strict';

  /* Guard against the script being evaluated twice (theme editor section reloads). */
  if (window.__akCaseStudyLoaded) return;
  window.__akCaseStudyLoaded = true;

  var teardown = null;
  var ROOT_ID = 'anshul-kapoor-case-study';

  function clamp(value, min, max) { return Math.max(min, Math.min(max, value)); }

  function init(root) {
    if (!root || root.dataset.akReady) return;
    root.dataset.akReady = 'true';

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var wide = window.matchMedia('(min-width: 990px)');
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
    var items = Array.prototype.slice.call(root.querySelectorAll('.ak-reveal'));
    var layers = Array.prototype.slice.call(root.querySelectorAll('[data-ak-depth]'));
    var videos = Array.prototype.slice.call(root.querySelectorAll('video'));
    var hero = root.querySelector('[data-ak-pointer]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ak-cards] .ak-card'));
    var io = null;
    var ticking = false;
    var pointerFrame = 0;
    var cleanups = [];

    function motionOk() { return !reduced.matches; }
    function pointerOk() { return motionOk() && fine.matches && wide.matches; }

    /* Testimonial cards stagger in, then drop the delay so hover and tap respond instantly. */
    function reveal(el) {
      el.classList.add('ak-is-visible');
      window.setTimeout(function () { el.style.transitionDelay = '0s'; }, 1800);
    }
    function showAll() {
      items.forEach(function (el) { el.classList.add('ak-is-visible'); el.style.transitionDelay = '0s'; });
    }

    /* Scroll reveals. The hidden state only exists once .ak-js is set, so content stays visible if this script never runs. */
    function startReveals() {
      if (io || !('IntersectionObserver' in window)) return;
      io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          /* Reveal anything intersecting or already scrolled past (e.g. reload mid-page). */
          if (!entry.isIntersecting && entry.boundingClientRect.top > 0) return;
          reveal(entry.target);
          obs.unobserve(entry.target);
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
      items.forEach(function (el) { if (!el.classList.contains('ak-is-visible')) io.observe(el); });
    }

    /* Scroll-linked depth: a small, clamped translateY per layer. Smaller on narrow screens. */
    function update() {
      ticking = false;
      var vh = window.innerHeight || 1;
      var scale = wide.matches ? 1 : 0.4;
      layers.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < -300 || rect.top > vh + 300) return;
        var factor = parseFloat(el.getAttribute('data-ak-depth')) || 0;
        var max = (parseFloat(el.getAttribute('data-ak-max')) || 28) * scale;
        var offset = (rect.top + rect.height / 2 - vh / 2) * factor * scale;
        el.style.setProperty('--ak-shift', clamp(offset, -max, max).toFixed(1) + 'px');
      });
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }
    function bindScroll() {
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();
    }
    function unbindScroll() {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      layers.forEach(function (el) { el.style.removeProperty('--ak-shift'); });
    }

    /* Desktop pointer depth. Values are -1..1 CSS variables; leaving settles everything back to alignment. */
    function setPointer(el, event) {
      var rect = el.getBoundingClientRect();
      var x = clamp(((event.clientX - rect.left) / rect.width) * 2 - 1, -1, 1);
      var y = clamp(((event.clientY - rect.top) / rect.height) * 2 - 1, -1, 1);
      return [x.toFixed(3), y.toFixed(3)];
    }
    function bindPointer(el, xName, yName) {
      if (!el) return;
      var pending = null;
      function flush() {
        pointerFrame = 0;
        if (!pending) return;
        el.style.setProperty(xName, pending[0]);
        el.style.setProperty(yName, pending[1]);
        pending = null;
      }
      function onMove(event) {
        if (!pointerOk() || event.pointerType === 'touch') return;
        pending = setPointer(el, event);
        if (!pointerFrame) pointerFrame = window.requestAnimationFrame(flush);
      }
      function onLeave() {
        pending = null;
        el.style.setProperty(xName, '0');
        el.style.setProperty(yName, '0');
      }
      el.addEventListener('pointermove', onMove);
      el.addEventListener('pointerleave', onLeave);
      cleanups.push(function () {
        el.removeEventListener('pointermove', onMove);
        el.removeEventListener('pointerleave', onLeave);
        el.style.removeProperty(xName);
        el.style.removeProperty(yName);
      });
    }
    bindPointer(hero, '--ak-px', '--ak-py');
    cards.forEach(function (card) { bindPointer(card, '--ak-cx', '--ak-cy'); });

    function applyMode() {
      if (reduced.matches) {
        if (io) { io.disconnect(); io = null; }
        unbindScroll();
        showAll();
      } else {
        startReveals();
        unbindScroll();
        bindScroll();
      }
    }

    root.classList.add('ak-js');
    if (!('IntersectionObserver' in window)) showAll();
    applyMode();

    function listen(query, handler) {
      if (query.addEventListener) query.addEventListener('change', handler);
      else if (query.addListener) query.addListener(handler);
    }
    function unlisten(query, handler) {
      if (query.removeEventListener) query.removeEventListener('change', handler);
      else if (query.removeListener) query.removeListener(handler);
    }
    listen(reduced, applyMode);
    listen(wide, applyMode);

    /* Touch devices only apply :active once a touch listener exists (iOS Safari). */
    function noop() {}
    root.addEventListener('touchstart', noop, { passive: true });

    /* Videos: native controls stay as the no-JS fallback. With JS a poster plus play button is shown,
       playback starts only on a tap or click, never autoplays, and only one film plays at a time. */
    var plays = [];
    videos.forEach(function (video) {
      var button = video.parentNode.querySelector('[data-ak-play]');
      if (!button) return;
      video.removeAttribute('controls');
      function start() {
        video.setAttribute('controls', '');
        button.classList.add('is-hidden');
        var attempt = video.play();
        if (attempt && attempt.catch) attempt.catch(function () { button.classList.remove('is-hidden'); video.removeAttribute('controls'); });
      }
      button.addEventListener('click', start);
      plays.push({ button: button, start: start, video: video });
    });
    var onPlay = function (event) {
      videos.forEach(function (other) { if (other !== event.target && !other.paused) other.pause(); });
    };
    videos.forEach(function (video) { video.addEventListener('play', onPlay); });

    teardown = function () {
      if (io) io.disconnect();
      if (pointerFrame) window.cancelAnimationFrame(pointerFrame);
      pointerFrame = 0;
      unbindScroll();
      cleanups.forEach(function (fn) { fn(); });
      unlisten(reduced, applyMode);
      unlisten(wide, applyMode);
      root.removeEventListener('touchstart', noop);
      plays.forEach(function (p) { p.button.removeEventListener('click', p.start); p.video.setAttribute('controls', ''); p.button.classList.remove('is-hidden'); });
      videos.forEach(function (video) { video.removeEventListener('play', onPlay); video.pause(); });
      root.classList.remove('ak-js');
      delete root.dataset.akReady;
      teardown = null;
    };
  }

  function ours(event) {
    var t = event && event.target;
    return !t || !t.querySelector || t.id === ROOT_ID || !!t.querySelector('#' + ROOT_ID);
  }
  function scan(event) {
    if (!ours(event)) return;
    if (teardown) teardown();
    init(document.getElementById(ROOT_ID));
  }
  function release(event) {
    if (ours(event) && teardown) teardown();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', release);
})();
